export default "__VITE_ASSET__OsrlKeeF__"